"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _default = exports["default"] = function _default(_ref) {
  var via = _ref.via;
  return /*#__PURE__*/_react["default"].createElement("span", {
    className: "text-xs text-gray-light"
  }, "\xA0", /*#__PURE__*/_react["default"].createElement("span", {
    className: "text-dark underline"
  }, "via"), "\xA0", via, "\xA0");
};
//# sourceMappingURL=index.js.map